<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><em>To my friend Madeline Trezza,<br/>her husband Tony,<br/>and her children Dana and Anthony.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795319648_epub_ded_r1.vue?37498352